// src/pages/Home.js

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import banner1 from '../assets/banner1.png';
import banner2 from '../assets/banner2.png';
import banner3 from '../assets/banner3.png';

import img1 from '../assets/1financial_management.png';
import img2 from '../assets/2financial_dvisory.png';
import img3 from '../assets/3transaction_advisory.png';
import img4 from '../assets/4capital raising.png';
import img5 from '../assets/5advanced_cashflow_management.png';
import img6 from '../assets/6growth_centric_financial_strategy.png';
import img7 from '../assets/7technology_integration.png';
import img8 from '../assets/8risk_management.png';
import img9 from '../assets/9accounting_bookkeeping.png';
import img10 from '../assets/10tax_advisory.png';

import csvFile from '../assets/whitepapers.csv';

const safeImageLoad = (imageName) => {
  try {
    return require(`../assets/${imageName}.png`);
  } catch (err) {
    try {
      return require(`../assets/${imageName}.jpg`);
    } catch (e) {
      return null;
    }
  }
};

function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [hoveredService, setHoveredService] = useState(null);
  const [insights, setInsights] = useState([]);

  const slides = [
    {
      id: 1,
      title: "Scalable Resources And Expertise",
      subtitle: "We seamlessly integrate specialized talent to expand your operational capabilities instantly.",
      image: banner1
    },
    {
      id: 2,
      title: "Strategic Financial Leadership Partners",
      subtitle: "We guide your company decisions with expert financial oversight and strategic foresight.",
      image: banner2
    },
    {
      id: 3,
      title: "Driving Comprehensive Business Expansion",
      subtitle: "We accelerate your corporate growth through targeted acquisitions and internal scaling strategies.",
      image: banner3
    }
  ];

  const servicesList = [
    { name: "Financial Management Services", image: img1 },
    { name: "Financial Advisory", image: img2 },
    { name: "Transaction Advisory (M&A)", image: img3 },
    { name: "Capital Raising & Investor Relations", image: img4 },
    { name: "Advanced Cash Flow Management", image: img5 },
    { name: "Growth-Centric Financial Strategy & Modeling", image: img6 },
    { name: "Technology Integration & System Architecture", image: img7 },
    { name: "Risk Management, Governance, & Restructuring", image: img8 },
    { name: "Accounting & Bookkeeping Services", image: img9 },
    { name: "Tax Advisory & Compliance", image: img10 }
  ];

  const whyChooseUsPoints = [
    { text: "100+ years cumulative experience of founders", icon: "🧠" },
    { text: "50+ elite resources including CAs, CFAs, MBAs", icon: "👥" },
    { text: "Automated & Tech-Driven Financial Workflows", icon: "⚙️" },
    { text: "Organic and Inorganic expansion support", icon: "📈" },
    { text: "Research and consulting capabilities", icon: "🔍" },
    { text: "Global Capability Center (GCC) Arbitrage", icon: "🌐" }
  ];

  useEffect(() => {
    slides.forEach((slide) => {
      const img = new Image();
      img.src = slide.image;
    });
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  useEffect(() => {
    const parseCSV = (text) => {
      const result = [];
      let row = [];
      let inQuotes = false;
      let val = '';
      for (let i = 0; i < text.length; i++) {
        let char = text[i];
        let nextChar = text[i + 1];
        if (char === '"' && inQuotes && nextChar === '"') {
          val += '"'; i++;
        } else if (char === '"') {
          inQuotes = !inQuotes;
        } else if (char === ',' && !inQuotes) {
          row.push(val.trim()); val = '';
        } else if ((char === '\n' || char === '\r') && !inQuotes) {
          if (char === '\r' && nextChar === '\n') i++;
          row.push(val.trim());
          if (row.some(field => field !== '')) result.push(row);
          row = []; val = '';
        } else {
          val += char;
        }
      }
      if (val || row.length > 0) {
        row.push(val.trim());
        result.push(row);
      }
      return result;
    };

    fetch(csvFile)
      .then(response => response.text())
      .then(csvText => {
        const rows = parseCSV(csvText);
        if (rows.length > 1) {
          const headers = rows[0];
          const parsedData = rows.slice(1).map(row => {
            let obj = {};
            headers.forEach((header, index) => {
              obj[header.trim()] = row[index] || '';
            });
            return obj;
          });
          setInsights(parsedData.filter(p => p.Title).slice(0, 3));
        }
      })
      .catch(err => console.error("Error loading CSV:", err));
  }, []);

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', color: '#333' }}>
      
      <div style={{ display: 'none' }}>
        <img src={banner1} alt="preload" />
        <img src={banner2} alt="preload" />
        <img src={banner3} alt="preload" />
      </div>

      {/* 1. Sliding Banner Section */}
      <section style={{ 
        ...styles.banner, 
        backgroundImage: `url(${slides[currentSlide].image})`
      }}>
        <div style={styles.bannerOverlay}></div>
        <div style={styles.bannerContent}>
          <div style={styles.textWrapper}>
            <h1 style={styles.headingWrapper}>
              <span style={styles.bannerTitle}>{slides[currentSlide].title}</span>
            </h1>
            <p style={styles.paragraphWrapper}>
              <span style={styles.bannerSubtitle}>{slides[currentSlide].subtitle}</span>
            </p>
          </div>
          <Link to="/contact" style={styles.primaryButton}>Partner With Us</Link>
        </div>
        <div style={styles.sliderDots}>
          {slides.map((_, index) => (
            <span 
              key={index} 
              style={{
                ...styles.dot, 
                backgroundColor: currentSlide === index ? '#fff' : 'rgba(255,255,255,0.5)'
              }}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </section>

      {/* 2. Insights Section */}
      <section style={styles.insightsSection}>
        <h2 style={styles.insightsTitle}>Latest Insights</h2>
        <div style={styles.insightsGrid}>
          {insights.map((insight, index) => {
            const img1 = safeImageLoad(`${insight.Slno}_image_1`);
            return (
              <div key={index} style={styles.card}>
                <div style={styles.insightImageContainer}>
                  {img1 ? (
                    <img src={img1} alt={insight.Title} style={styles.insightImage} />
                  ) : (
                    <div style={styles.cardImagePlaceholder}>Image Placeholder</div>
                  )}
                </div>
                <div style={styles.cardContent}>
                  <h3 style={styles.cardTitle}>{insight.Title}</h3>
                  <Link to={`/resources?id=${insight.Slno}`} style={styles.readMoreBtn}>
                    Read More &rarr;
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* 3. Our Services Section */}
      <section style={{ ...styles.section, backgroundColor: '#F4F7F9' }}>
        <div style={styles.sectionHeader}>
          <h2 style={styles.sectionTitle}>Our Services</h2>
          <p style={styles.sectionSubtitle}>Comprehensive financial solutions tailored for strategic growth and operational excellence.</p>
        </div>
        <div style={styles.grid5}>
          {servicesList.map((service, index) => {
            const slug = service.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
            const isHovered = hoveredService === index;
            
            return (
              <Link to={`/services/${slug}`} key={index} style={{ textDecoration: 'none', display: 'flex', height: '100%' }}>
                <div 
                  style={{
                    ...styles.serviceBox,
                    ...(isHovered ? styles.serviceBoxHover : {})
                  }}
                  onMouseEnter={() => setHoveredService(index)}
                  onMouseLeave={() => setHoveredService(null)}
                >
                  <div style={styles.serviceImageContainer}>
                    <img 
                      src={service.image} 
                      alt={service.name}
                      style={{
                        ...styles.serviceImage,
                        ...(isHovered ? styles.serviceImageHover : {})
                      }}
                    />
                  </div>
                  
                  <div style={styles.serviceContent}>
                    <h4 style={{
                      ...styles.serviceTitle,
                      ...(isHovered ? styles.serviceTitleHover : {})
                    }}>{service.name}</h4>
                    
                    <div style={styles.exploreWrapper}>
                      <span style={{
                        ...styles.exploreText,
                        ...(isHovered ? styles.exploreTextHover : {})
                      }}>
                        Explore <span style={styles.arrow}>&rarr;</span>
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      {/* 4. Value Proposition Section (Milestone Style) */}
      <section style={{ ...styles.section, backgroundColor: '#ffffff' }}>
        <div style={styles.sectionHeader}>
          <h2 style={styles.sectionTitle}>Why Choose Us</h2>
          <p style={styles.sectionSubtitle}>The pillars of our practice that ensure your sustainable success.</p>
        </div>
        <div style={styles.milestoneGrid}>
          {whyChooseUsPoints.map((point, index) => (
            <div key={index} style={styles.milestoneCard}>
              <div style={styles.milestoneBadge}>
                {point.icon}
              </div>
              <h4 style={styles.milestoneText}>{point.text}</h4>
            </div>
          ))}
        </div>
      </section>

      {/* 5. Talk to Us Section */}
      <section style={styles.ctaSection}>
        <h2 style={{ fontSize: '32px', marginBottom: '20px' }}>Ready to transform your business?</h2>
        <p style={{ fontSize: '18px', marginBottom: '30px' }}>Connect with our leadership team to discuss your strategic objectives.</p>
        <Link to="/contact" style={styles.secondaryButton}>Talk to our Experts</Link>
      </section>

    </div>
  );
}

const styles = {
  banner: { 
    height: '600px', 
    display: 'flex', 
    flexDirection: 'column', 
    justifyContent: 'center', 
    alignItems: 'center', 
    color: '#fff', 
    textAlign: 'center', 
    transition: 'background-image 0.5s ease', 
    position: 'relative', 
    padding: '0 20px', 
    backgroundColor: '#001524',
    backgroundSize: 'cover', 
    backgroundPosition: 'center', 
    backgroundRepeat: 'no-repeat' 
  },
  bannerOverlay: { position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 43, 73, 0.25)', zIndex: 1 },
  bannerContent: { maxWidth: '900px', zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' },
  textWrapper: { marginBottom: '30px', textAlign: 'center', width: '100%' },
  headingWrapper: { margin: '0 0 15px 0' },
  paragraphWrapper: { margin: '0 auto', maxWidth: '800px' },
  bannerTitle: { 
    fontSize: 'clamp(32px, 5vw, 48px)',
    fontWeight: 'bold', 
    color: '#ffffff', 
    textShadow: '2px 4px 8px rgba(0,0,0,0.8), 0px 0px 20px rgba(0,0,0,0.6)',
    lineHeight: '1.2'
  },
  bannerSubtitle: { 
    fontSize: 'clamp(16px, 3vw, 20px)',
    color: '#ffffff', 
    textShadow: '1px 2px 6px rgba(0,0,0,0.9), 0px 0px 15px rgba(0,0,0,0.7)',
    lineHeight: '1.6'
  },
  primaryButton: { backgroundColor: '#E1261C', color: '#fff', padding: '15px 30px', textDecoration: 'none', fontSize: '18px', fontWeight: 'bold', borderRadius: '4px', boxShadow: '0 4px 6px rgba(0,0,0,0.3)' },
  secondaryButton: { backgroundColor: '#fff', color: '#002B49', padding: '15px 30px', textDecoration: 'none', fontSize: '18px', fontWeight: 'bold', borderRadius: '4px' },
  sliderDots: { position: 'absolute', bottom: '30px', display: 'flex', gap: '10px', zIndex: 2 },
  dot: { width: '12px', height: '12px', borderRadius: '50%', cursor: 'pointer', boxShadow: '0 2px 4px rgba(0,0,0,0.5)' },
  section: { padding: '80px 5%' },
  sectionHeader: { textAlign: 'center', marginBottom: '50px' },
  sectionTitle: { fontSize: '36px', color: '#002B49', marginBottom: '15px', textAlign: 'center', fontWeight: 'bold' },
  sectionSubtitle: { fontSize: '18px', color: '#4B5563', maxWidth: '700px', margin: '0 auto' },
  
  // Updated Insights Section Styles
  insightsSection: { backgroundColor: '#F4F7F9', padding: '80px 5%', textAlign: 'center' },
  insightsTitle: { fontSize: '36px', color: '#002B49', fontWeight: 'bold', marginBottom: '50px' },
  insightsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px', maxWidth: '1200px', margin: '0 auto' },
  card: { backgroundColor: '#FFFFFF', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 4px 15px rgba(0, 43, 73, 0.05)', textAlign: 'left', display: 'flex', flexDirection: 'column' },
  cardContent: { padding: '25px', flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' },
  cardTitle: { fontSize: '18px', color: '#002B49', fontWeight: 'bold', marginBottom: '20px', lineHeight: '1.5' },
  readMoreBtn: { color: '#E1261C', backgroundColor: 'transparent', border: '1px solid #E1261C', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold', alignSelf: 'flex-start', textDecoration: 'none' },
  insightImageContainer: { width: '100%', height: '180px', overflow: 'hidden' },
  insightImage: { width: '100%', height: '100%', objectFit: 'cover' },
  cardImagePlaceholder: { backgroundColor: '#F3F4F6', height: '100%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#9CA3AF' },
  
  grid5: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', alignItems: 'stretch' },
  serviceBox: { 
    width: '100%', 
    backgroundColor: '#fff',
    borderRadius: '16px',
    border: '1px solid #E5E7EB',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.03)', 
    textAlign: 'center', 
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)', 
    minHeight: '280px',
    position: 'relative',
    overflow: 'hidden'
  },
  serviceBoxHover: {
    transform: 'translateY(-10px)',
    boxShadow: '0 20px 25px -5px rgba(0, 43, 73, 0.1), 0 10px 10px -5px rgba(0, 43, 73, 0.04)',
    borderColor: '#002B49'
  },
  serviceImageContainer: { width: '100%', height: '140px', overflow: 'hidden', marginBottom: '20px' },
  serviceImage: { width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s ease' },
  serviceImageHover: { transform: 'scale(1.05)' },
  serviceContent: { padding: '0 20px 25px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, width: '100%' },
  serviceTitle: { fontSize: '17px', marginBottom: '15px', color: '#111827', lineHeight: '1.4', transition: 'color 0.3s ease' },
  serviceTitleHover: { color: '#002B49' },
  exploreWrapper: { marginTop: 'auto', paddingTop: '15px' },
  exploreText: { color: '#E1261C', fontSize: '15px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px', transition: 'all 0.3s ease' },
  exploreTextHover: { color: '#002B49' },
  arrow: { transition: 'transform 0.3s ease' },
  
  milestoneGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '50px 30px', width: '100%', paddingTop: '30px' },
  milestoneCard: { position: 'relative', backgroundColor: '#fff', padding: '45px 30px 30px', borderRadius: '12px', border: '1px solid #E5E7EB', borderBottom: '4px solid #002B49', boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05)', textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'transform 0.3s ease', minHeight: '120px' },
  milestoneBadge: { position: 'absolute', top: '-25px', left: '50%', transform: 'translateX(-50%)', width: '50px', height: '50px', backgroundColor: '#E1261C', color: '#fff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px', border: '4px solid #fff', boxShadow: '0 4px 10px rgba(225, 38, 28, 0.2)' },
  milestoneText: { fontSize: '18px', color: '#111827', fontWeight: '600', lineHeight: '1.5', margin: 0 },
  ctaSection: { backgroundColor: '#E1261C', color: '#fff', padding: '80px 5%', textAlign: 'center' }
};

export default Home;